// Based om https://javascript.plainenglish.io/how-to-find-the-caret-inside-a-contenteditable-element-955a5ad9bf81

import { getNodePath } from './get-event-path';

export const getSelectedTextRect = (element: HTMLElement) => {
  const range = getSelectedRange(element);
  if (!range) return;

  const rects = Array.from(range.getClientRects());
  const left = Math.min(...rects.map(r => r.left));
  const top = Math.min(...rects.map(r => r.top));
  const bottom = Math.max(...rects.map(r => r.bottom));
  const right = Math.max(...rects.map(r => r.right));
  const width = right - left;

  const rect = <DOMRect>{
    top,
    bottom,
    left,
    width,
  };
  if (!rect) return;

  return rect;
};

export const getSelectedText = (element: HTMLElement) => {
  const range = getSelectedRange(element);
  if (!range) return;
  return range.cloneContents().textContent;
};

export const getSelectedTextNodeMeta = (element: HTMLElement) => {
  const isSupported = typeof window.getSelection !== 'undefined';
  if (!isSupported) return;
  const selection = window.getSelection();

  if (!selection?.anchorNode) return;
  if (selection.rangeCount == 0) return;
  const path = getNodePath(selection.anchorNode);
  if (path.indexOf(element) === -1) return;

  const bold = path.some(el => getNodePath(el).some(n => n['tagName'] === 'B'));
  const italic = path.some(el => getNodePath(el).some(n => n['tagName'] === 'I'));
  const href = path.some(el => getNodePath(el).some(n => n['tagName'] === 'A'));

  return { bold, italic, href };
};

const getSelection = (element: HTMLElement) => {
  const isSupported = typeof window.getSelection !== 'undefined';
  if (!isSupported) return;
  const selection = window.getSelection();
  if (!selection?.focusNode) return;
  if (selection.rangeCount == 0) return;
  const path = getNodePath(selection.focusNode);
  if (path.indexOf(element) === -1) return;
  return selection;
};

export const getSelectedRange = (element: HTMLElement) => {
  const selection = getSelection(element);
  if (!selection) return;
  return selection.getRangeAt(0).cloneRange();
};

export const fullySelectSelectedLink = (element: HTMLElement) => {
  const selection = getSelection(element);
  const aElement = getSelectedLink(element);
  if (!aElement) return;
  const range = new Range();
  range.selectNode(aElement);
  selection.removeAllRanges();
  selection.addRange(range);
};

export const getSelectedLink = (element: HTMLElement) => {
  const selection = getSelection(element);
  if (!selection) return;
  let el = <HTMLElement>selection.focusNode;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    if (!el) return;
    if (el.tagName === 'A') return el;
    el = el.parentElement;
  }
};
